import {
  FRAME_COLORS,
  MATERIAL_TYPES,
  MATTING,
} from '@mixtiles/web-backend-shared'

// Only support these exact combinations because we don't have assets for all the combinations
const SUPPORTED_COMBINATIONS: [MATERIAL_TYPES, FRAME_COLORS][] = [
  [MATERIAL_TYPES.CLASSIC, FRAME_COLORS.BLACK],
  [MATERIAL_TYPES.CLASSIC, FRAME_COLORS.WOOD],
  [MATERIAL_TYPES.WIDE_FRAME, FRAME_COLORS.BLACK],
  [MATERIAL_TYPES.WIDE_FRAME, FRAME_COLORS.WHITE],
  [MATERIAL_TYPES.WIDE_FRAME, FRAME_COLORS.RED_ASH_WOOD],
]

const TOP_ORDER = [
  SUPPORTED_COMBINATIONS[0],
  SUPPORTED_COMBINATIONS[4],
  SUPPORTED_COMBINATIONS[1],
  SUPPORTED_COMBINATIONS[2],
  SUPPORTED_COMBINATIONS[3],
]

const BOTTOM_ORDER = [
  SUPPORTED_COMBINATIONS[0],
  SUPPORTED_COMBINATIONS[3],
  SUPPORTED_COMBINATIONS[1],
  SUPPORTED_COMBINATIONS[2],
  SUPPORTED_COMBINATIONS[4],
]

// Return frame props: materialType and frameColor determined according to index and matting is random
export function getFrameProps(
  index: number,
  row: 'top' | 'bottom'
): {
  materialType: MATERIAL_TYPES
  frameColor: FRAME_COLORS
  matting: MATTING
} {
  const order = row === 'top' ? TOP_ORDER : BOTTOM_ORDER
  const [materialType, frameColor] = order[index % order.length]
  return { materialType, frameColor, matting: MATTING.NONE }
}
